import React from "react";
import Footer from "./Layout/Footer";
import Button from "../components/Button";
import { ArrowRightIcon, UserPlusIcon } from "@heroicons/react/24/outline";
import logo from "../assets/Ritex.png"; // Uncomment and set your logo path if you have one

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col justify-between bg-white relative overflow-x-hidden">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 pointer-events-none select-none z-0">
        <svg width="100%" height="100%">
          <circle cx="80%" cy="10%" r="180" fill="#3b82f6" fillOpacity="0.07" />
          <circle cx="10%" cy="80%" r="120" fill="#3b82f6" fillOpacity="0.04" />
        </svg>
      </div>
      <div className="flex flex-1 flex-col items-center justify-center relative z-10">
        <div className="relative bg-white/95 shadow-2xl border border-blue-100 rounded-3xl px-10 py-16 flex flex-col items-center w-full max-w-xl mt-24 mb-20 backdrop-blur-sm">
          {/* Logo or Icon */}
          <img src={logo} alt="Logo" className="w-28 h-28 " />
          <div className="w-16 h-1 bg-bluePrimary rounded-full mb-6" />
          <h1 className="text-bluePrimary font-extrabold text-5xl mb-2 tracking-tight text-center ">
            RitexApp
          </h1>
          <h5 className="text-gray-700 font-semibold text-xl mb-4 text-center">
            Simplify your print and logistics journey with{" "}
            <span className="text-bluePrimary font-bold">RitexApp</span>
          </h5>
          <span className="inline-block mb-8 px-4 py-2 bg-bluePrimary/10 text-bluePrimary rounded-full font-semibold text-sm tracking-wide shadow">
            Fast • Reliable • Secure
          </span>
          <div className="flex gap-4 mt-2">
            <a href="/register">
              <Button
                variant="outline"
                size="md"
                icon={<UserPlusIcon className="h-5 w-5" />}
                className="font-semibold transition-all duration-200 hover:scale-105"
              >
                Sign Up
              </Button>
            </a>
            <a href="/login">
              <Button
                variant="primary"
                size="md"
                icon={<ArrowRightIcon className="h-5 w-5" />}
                className="font-bold transition-all duration-200 hover:scale-105"
              >
                Log In
              </Button>
            </a>
          </div>
        </div>
      </div>
      <Footer />
      <div className="mb-6" />
    </div>
  );
}
